import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import Sidebar from "../../components/admin/Sidebar";
import Header from "../../components/admin/Header";

const AdminLayout = () => {
  return (
    <Box>
      <Header />
      <Flex pt="60px">
        <Sidebar />
        <Box flex="1" p={8} bg="#f7fafd" minH="calc(100vh - 60px)">
          <Outlet />
        </Box>
      </Flex>
    </Box>
  );
};

export default AdminLayout;
